// extracted by mini-css-extract-plugin
module.exports = {"DownloadsActions":"ActionButtons_DownloadsActions__2in8s","ActionButtons":"ActionButtons_ActionButtons__51nAt","ActionButton":"ActionButtons_ActionButton__3ZR-2"};